import variables from "./variables";

const config = {
  name: 'base',
  variables,
}

export default config;